import { render, staticRenderFns } from "./_promoCards.vue?vue&type=template&id=23bca1cd&scoped=true&"
import script from "./_promoCards.vue?vue&type=script&lang=js&"
export * from "./_promoCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bca1cd",
  null
  
)

export default component.exports